import React, { Component } from 'react';
import headshot from './dw.jpg';
import './About.scss';

export default class About extends Component {
  render() {
    return (
      <section id="about" className="section">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-4">
              <div className="personal-pic">
                <img src={headshot} title="" alt="" />
              </div>
            </div>

            <div className="col-xs-12 col-sm-8">
              <div className="personal-info">
                <div className="section-title left">
                  <h2>About <span>Me</span></h2>
                </div>
                <h3>Hi, I&apos;m David Willoughby</h3>
                <p>I&apos;m a full-stack developer &amp; app architect with a long history of designing and building custom software, lately focusing on mobile apps (native and HTML5) and the server architecture to support them. I build and maintain servers, design database structure, develop backend APIs and Content Management Systems, and user-facing clients.</p>
                <p>A lot of my work in the 2000s was for corporate clients, often using .NET or Java, but for the past few years I&apos;ve been mostly using Rails and Node.js on Linux servers, trying lots of newer HTML5 and native mobile tech. I&apos;m capable with most common languages / frameworks, and work extensively with Javascript frameworks. I have developed over 100 mobile apps in the iTunes &amp; Google Play stores.</p>
                <div className="social-link">
                  <ul>
                    <li>
                      <a href="https://www.linkedin.com/in/dwilloughby/">
                        <i className="fa fa-linkedin" aria-hidden="true"></i>
                      </a>
                    </li>
                    <li>
                      <a href="https://twitter.com/dwilloughby">
                        <i className="fa fa-twitter"></i>
                      </a>
                    </li>
                    <li>
                      <a href="https://github.com/wired247">
                        <i className="fa fa-github"></i>
                      </a>
                    </li>
                    <li>
                      <a href="https://www.facebook.com/wireddavid">
                        <i className="fa fa-facebook"></i>
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="about-actions">
                  <button className="m-btn lets-talk">contact me</button>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/About.js